import React from 'react';
import ExternalSearchHighlight from '../ExternalSearchHighlight';
import styles from './SlackText.module.scss';

const HIGHLIGHT_START = '\ue000';
const HIGHLIGHT_END = '\ue001';

interface SlackTextProps {
  text: string;
}

// TODO: Render the whole message properly based on
// https://api.slack.com/docs/message-formatting#how_to_display_formatted_messages
const SlackText = ({ text }: SlackTextProps) => (
  <div className={styles.text}>
    <ExternalSearchHighlight
      html={text.replace(/<([^>]+)>/gi, '$1')}
      highlightStart={HIGHLIGHT_START}
      highlightEnd={HIGHLIGHT_END}
    />
  </div>
);

export default SlackText;
